<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">SubCategories</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>SubCategories</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toSubCategoryCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增分類</span>
      </button>
    </div>
    <!-- Table -->
    <SubCategoryTable></SubCategoryTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SubCategoryTable from '@/views/C-2__SubCategory/c/SubCategoryTable.vue';

export default {
  components: {
    SubCategoryTable,
  },
  async created() {
    this.clear();
    await this.getSubCategories();
  },
  methods: {
    ...mapActions('subcategory', {
      getSubCategories: 'find',
      clear: 'clear',
    }),
    toSubCategoryCreate() {
      this.$router.push({ name: 'SubCategoryCreate' });
    },
  },
};
</script>

<style></style>
